<template>
  <div class="event-list">
    <div v-if="isLoading" class="text-center py-5">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
      <p class="mt-3 text-muted">{{ copy.loading }}</p>
    </div>

    <div v-else-if="events.length === 0" class="text-center py-5">
      <i class="fa fa-search fa-3x text-muted mb-3"></i>
      <p class="text-muted">{{ copy.noResults }}</p>
    </div>

    <div v-else class="list-group">
      <event-list-item
        v-for="event in events"
        :key="event.path"
        :event="event"
      ></event-list-item>
    </div>
  </div>
</template>

<script>
import EventListItem from './event_list_item.vue';

export default {
  props: ['events', 'isLoading', 'copy'],

  components: { EventListItem }
};
</script>

<style scoped>
.event-list .list-group {
  border-radius: 0.25rem;
}
</style>
